module.exports = __webpack_public_path__ + "img/logo-dashboard.8e25201f.svg";